import { AddressSchema } from "@redotech/account-common/address";
import { InteractiveMapLocationSchema } from "@redotech/redo-model/draft-return/draft-return";
import { dropoffProviderType } from "@redotech/redo-model/dropoff/dropoff-provider";
import {
  ReturnAddressSchema,
  type ReturnAddressZod,
} from "@redotech/redo-model/return";
import * as z from "zod";

/**
 * Customer address the nearby drop-off search is centered on. Reuses the
 * canonical return-address shape: the location fields (geocoded server-side when
 * latitude/longitude are absent) plus the provider routing fields
 * (blueYonderLocationId / returnsCenterId / externalReturnHub) that select which
 * return network the search runs against. Self-contained so the search needs
 * neither a return nor a shipment group to resolve any of this.
 */
export type DropoffSearchAddress = ReturnAddressZod;

export const getDropoffLocations = {
  name: "getDropoffLocations" as const,
  input: z.object({
    teamId: z.string(),
    provider: z.enum(dropoffProviderType),
    customerAddress: ReturnAddressSchema,
    merchantAddress: AddressSchema,
  }),
  output: z.object({ locations: z.array(InteractiveMapLocationSchema) }),
};
